export default function Go_Constants () {
  return (
    <div>
      <h1>Go_Constants </h1>
      <p>Go Constants</p>
    </div>
  );
}